import { gameConfig } from '../../../config'
import { buyBonusBigWin } from './buyBOnusApiMock'
import { BuyBonusRequest } from './BuyBonusRequest'
import { BuyBonusResponse } from './BuyBonusResponse'
import { apiClient } from '@slot-nx/core'

export interface IBuyBonusApi {
  buyBonus: (input: BuyBonusRequest) => Promise<BuyBonusResponse>
}

export const buyBonusApi: IBuyBonusApi = {
  async buyBonus(input: BuyBonusRequest): Promise<BuyBonusResponse> {
    const response = await apiClient.post<BuyBonusResponse>(`${gameConfig.name}/BuyBonus`, input)
    return response.data
  },
}

export const mockBuyBonusApi: IBuyBonusApi = {
  buyBonus(): Promise<BuyBonusResponse> {
    return new Promise<BuyBonusResponse>((resolve) => {
      setTimeout(() => {
        resolve(buyBonusBigWin)
      }, 1000)
    })
  },
}
